import React, { Component } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import cn from 'classnames';

import { isAssigned } from 'actions/ab';
import { HYDRA_COLA } from 'constants/hydraTests';
import { AppState } from 'types/app';
import { SimilarStyles } from 'types/product';
import { ProductStockData } from 'types/cloudCatalog';

import css from 'styles/components/productdetail/outOfStockPopoverWrapper.scss';

export const OutOfStockPopover = loadable(() => import('components/productdetail/OutOfStockPopover'));

interface Props {
  brandId: string;
  brandName: string;
  hydraCola: boolean;
  recos?: SimilarStyles;
  stock: ProductStockData | null;
  isSubmitted: boolean;
  onBrandNotifySubmit: any; // TODO type this when `Brand` types are finished
  onShow: () => void;
}

interface State {
  visible: null | boolean;
}

export class OutOfStockPopoverWrapper extends Component<Props, State> {
  state = {
    visible: null
  };

  componentDidUpdate(prevProps: Props) {
    const { stock, onShow } = this.props;
    if (stock !== prevProps.stock) {
      this.setState({ visible: null });
    }
    if (!stock && prevProps.stock && this.state.visible === null) {
      onShow();
    }
  }

  onCloseClick = () => {
    this.setState({ visible: false });
  };

  render() {
    const { visible } = this.state;
    const { hydraCola, stock } = this.props;
    // Set initial visibility based on props (product is out of stock)
    // Subsequently, it should respect local state visibility when close button is clicked
    let isVisible;
    if (visible !== null) {
      isVisible = visible;
    } else {
      isVisible = !hydraCola && !stock;
    }
    return (
      <div className={cn(css.oosPopoverWrapper, { [css.slideIn]: isVisible })}>
        {isVisible && <OutOfStockPopover {...this.props} onCloseClick={this.onCloseClick} />}
      </div>
    );
  }
}

export const mapStateToProps = (state: AppState) => ({
  hydraCola: isAssigned(HYDRA_COLA, 1, state)
});

const connector = connect(mapStateToProps);

export default connector(OutOfStockPopoverWrapper);
